import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
	selector: 'app-main-header',
	template: `<h1 class="flex items-center justify-between gap-8 text-4xl font-bold">
		<ng-content></ng-content>
	</h1>`,
	standalone: true,
	imports: [CommonModule],
})
export class MainHeaderComponent {}
